import type React from "react";
import logo from "../../assets/logoblack.png";
import "./LogoLoader.css";

const LogoLoader: React.FC = () => {
  return (
    <div className="logo-loader" role="status" aria-live="polite" aria-label="Загрузка">
      <img src={logo} alt="" className="logo-loader__img" />
    </div>
  );
};

export default LogoLoader;
